/* FOM · nos ocultos — a prova visivel de que nada e destruido (I-2).

   No FOM nao existe DELETE: o papel do banco usado pela API nem sequer tem
   permissao de DELETE em tabela alguma. "Remover" e ocultar, e ocultar e
   reversivel. Se essa reversao nao aparecesse na tela, a invariante existiria
   apenas no papel — e ninguem confia numa garantia que nao consegue exercer.

   Sao DUAS restauracoes diferentes, e confundi-las seria perder informacao:

     reexibir           — o no volta como estava, COM as edicoes que recebeu;
     restaurar original — descarta as edicoes e traz de volta o que a BASE
                          dizia. So existe para no de origem `base`, e so
                          funciona porque `base_payload` e imutavel (I-1). */
import type { Api } from '../core/api.ts';
import type { FomNode } from '../core/types.ts';
import { ROTULO_ST } from '../core/types.ts';
import { el, botao, limpar, vazio, dataCurta } from './dom.ts';

export type OcultosOpcoes = {
  api: Api;
  org: string;
  mapa: string;
  /* o mapa precisa se recompor depois de uma restauracao */
  aoRestaurar: () => Promise<void>;
  aoErro: (erro: unknown) => void;
};

export function montarOcultos(host: HTMLElement, o: OcultosOpcoes) {
  let ocultos: FomNode[] = [];

  async function carregar(): Promise<void> {
    const todos = await o.api.nos(o.org, o.mapa, { incluirRemovidos: true });
    ocultos = todos.filter((n) => n.removed_at !== null);
  }

  async function restaurar(no: FomNode, escopo: 'visibility' | 'base'): Promise<void> {
    try {
      await o.api.restaurarNo(o.org, o.mapa, no.external_id, escopo);
      await o.aoRestaurar();
      await carregar();
      render();
    } catch (err) {
      o.aoErro(err);
    }
  }

  function render(): void {
    limpar(host);
    host.appendChild(el('h3', 'gaveta-titulo', 'Ocultos'));
    host.appendChild(el('p', 'gaveta-nota',
      'No FOM nada e destruido. O que sai do mapa continua no banco e pode voltar. '
      + 'Nao existe apagar — nem para quem opera, nem para a API.'));

    if (!ocultos.length) {
      host.appendChild(vazio('Nenhum no oculto.',
        'Tudo o que existe neste mapa esta visivel.'));
      return;
    }

    const ul = el('ul', 'lista-ocultos');
    for (const n of ocultos) {
      const li = el('li', 'oculto-item');

      const topo = el('div', 'oculto-topo');
      topo.appendChild(el('span', 'oculto-nome', n.name));
      topo.appendChild(el('span',
        'etiqueta ' + (n.origin === 'base' ? 'etiqueta-base' : 'etiqueta-user'),
        n.origin === 'base' ? 'BASE' : 'USER'));
      topo.appendChild(el('span', 'oculto-st', ROTULO_ST[n.st]));
      li.appendChild(topo);

      li.appendChild(el('span', 'oculto-data', 'oculto desde ' + dataCurta(n.removed_at)));

      const acoes = el('div', 'oculto-acoes');
      acoes.appendChild(botao('Reexibir', () => { void restaurar(n, 'visibility'); }, 'botao'));
      if (n.origin === 'base') {
        const orig = botao('Restaurar original',
          () => { void restaurar(n, 'base'); }, 'botao botao-camada');
        orig.title = 'descarta as edicoes e traz de volta o que a BASE congelada dizia';
        acoes.appendChild(orig);
      }
      li.appendChild(acoes);

      ul.appendChild(li);
    }
    host.appendChild(ul);
  }

  return {
    async mostrar(): Promise<void> {
      try {
        await carregar();
        render();
      } catch (err) {
        o.aoErro(err);
      }
    },
  };
}
